<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditWarehouseModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">{{ $t('warehouse.updateWarehouseTitle') }}</span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('columns.country') + ' *'"
                    v-model="formData.country"
                    :error-messages="errors.collect('Country')"
                    v-validate="'required'"
                    data-vv-name="Country"
                  />
                </v-flex>

                <v-flex xs6>
                  <v-text-field
                    :label="$t('columns.name') + ' *'"
                    v-model="formData.name"
                    :error-messages="errors.collect('Name')"
                    v-validate="'required'"
                    data-vv-name="Name"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('columns.city')"
                    v-model="formData.city"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('columns.code')"
                    v-model="formData.code"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('columns.street')"
                    v-model="formData.street"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('warehouse.estimateDaysLabel')"
                    type="number"
                    v-model.number="formData.estimate_days"
                    min="1"
                    max="365"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('columns.phoneNumber')"
                    v-model="formData.phone_number"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('warehouse.houseNumberLabel')"
                    v-model="formData.house_number"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md4
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('warehouse.stateProvinceLabel')"
                    v-model="formData.state_province"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md4
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('warehouse.prefixLabel')"
                    v-model="formData.prefix"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md4
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('columns.currency')"
                    v-model="formData.currency"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('warehouse.flagCodeHint')"
                    v-model="formData.flag_code"
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <v-text-field
                    :label="$t('warehouse.customCodeLabel')"
                    type="number"
                    v-model.number="formData.custom_code"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-select
                    :label="$t('warehouse.transportationTypesLabel')"
                    :items="transportationTypes"
                    item-text="name"
                    item-value="id"
                    v-model="formData.transportation_type_ids"
                    multiple
                    chips
                  />
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <label for="logo">{{ $t('columns.logo') }}</label>
                  <input
                    ref="logoRef"
                    type="file"
                    id="logo"
                    name="logo"
                    accept="image/*"
                    @input="logoChange()"
                  >
                </v-flex>

                <v-flex
                  xs12
                  md6
                  class="px-2"
                >
                  <label for="logo">{{ $t('warehouse.defaultImageLabel') }}</label>
                  <input
                    ref="defaultImageRef"
                    type="file"
                    id="logo"
                    name="logo"
                    accept="image/*"
                    @input="defaultImageChange()"
                  >
                </v-flex>

              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditWarehouseModal', 'formData', 'isUpdate', 'transportationTypes'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    logoChange() {
      this.formData.logo = this.$refs.logoRef.files[0]
    },

    defaultImageChange() {
      this.formData.default_image = this.$refs.defaultImageRef.files[0]
    },

    clearFiles() {
      this.$refs.logoRef.value = ''
      this.$refs.defaultImageRef.value = ''
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            let fd = new FormData()

            if (this.formData.transportation_type_ids.length) {
              this.formData.transportation_type_ids = this.formData.transportation_type_ids.join(',')
            }

            for (let key in this.formData) {
              const val = this.formData[key]
              if (key === 'estimate_days') {
                if (val !== null && val !== undefined && val !== '') {
                  fd.append(key, val)
                }
                continue
              }
              if (val) {
                fd.append(key, val)
              }
            }

            fd.append('_method', 'put')

            Axios.post(`api/warehouses/${this.formData.warehouse_id}`, fd, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.clearFiles()
                swal({
                  title: this.$t('common.updatedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          } else {
            let fd = new FormData()

            if (this.formData.transportation_type_ids.length) {
              this.formData.transportation_type_ids = this.formData.transportation_type_ids.join(',')
            }

            for (let key in this.formData) {
              const val = this.formData[key]
              if (key === 'estimate_days') {
                if (val !== null && val !== undefined && val !== '') {
                  fd.append(key, val)
                }
                continue
              }
              if (val) {
                fd.append(key, val)
              }
            }

            Axios.post(`api/warehouses`, fd, {
              headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            })
              .then(() => {
                this.clearFiles()
                swal({
                  title: this.$t('common.addedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouse/addEditWarehouse.vue